const getters = {
  jobvacancys: state => state.jobvacancy,
};

export default getters;
